import { PREMIUM_PRODUCT_TYPE_ID, PREMIUM_SUCCESS_URL, PURCHASE_TYPE } from './consts';
export function getSuccessUrl(metaSiteId) {
  const url = new URL(PREMIUM_SUCCESS_URL.PATH.replace('{{metaSiteId}}', metaSiteId));
  return url.toString();
}
export function getContext(productTypeId) {
  if (productTypeId === void 0) {
    productTypeId = PREMIUM_PRODUCT_TYPE_ID;
  }
  return {
    productTypeId,
    purchaseContext: {
      purchaseType: PURCHASE_TYPE
    }
  };
}
//# sourceMappingURL=utils.js.map